import React, { useRef, useState } from "react";
import * as d3 from "d3";
import { useEffect } from "react";

const VerticalBarChart = ({
    datasets,
    id,
    wrap,
    SetChartToolTip,
    SetChartToolTipKeyboard,
    ClearLocationToolTip,
    legendSymbols,
    stratificationID,
    deviceType,
}) => {
    useEffect(() => {
        changeData();
    }, [stratificationID]);

    const chartRef = useRef(null);

    const [stateIndex, setStateIndex] = useState(0);
    const [isFirst, setIsFirst] = useState(true);

    const verticalChartOverflow =
        datasets && datasets.DataItems.length > 4 ? "vertical-chart-overflow" : "";

    const margin = 50;
    const width = 650 - margin * 2;
    const height = 410 - margin * 2;

    function ShowVerticalBarChart(DataItems) {
        const currentChart = document.querySelector("svg#" + id);
        if (currentChart !== null) currentChart.remove();
        const margin = 40;
        const DataValueUnit =
            DataItems[0].DataValueType === "Number" ||
                DataItems[0].DataValueUnit === "gallons"
                ? ""
                : "(" + DataItems[0].DataValueUnit + ")";

        const svg = d3
            .select("#" + id)
            .append("svg")
            .attr("id", id)
            .attr("width", width + margin * 2)
            .attr(
                "height",
                DataItems[0].StratificationCategoryId === "RACE"
                    ? height + margin * 3.5
                    : height + margin * 2
            );

        const xScale = d3.scaleBand().range([0, width]).padding(0.4);
        const yScale = d3.scaleLinear().range([height, 0]);

        let g = svg
            .append("g")
            .attr("transform", "translate(60 " + margin + ")")
            .on("mouseout", function () {
                ClearLocationToolTip("clear");
            });

        xScale.domain(DataItems.map((d) => d.Stratification));
        yScale.domain([
            0,
            d3.max(DataItems, (d) =>
                d.HighConfidenceLimit === null
                    ? d.DataValue + d.DataValue / 10
                    : d.HighConfidenceLimit + d.HighConfidenceLimit / 10
            ),
        ]);

        function addFootnoteToLabel(e, index) {
            return DataItems[index].DataValueFootnoteSymbol === ""
                ? `${e}`
                : `${DataItems[index].DataValueFootnoteSymbol} ${e}`;
        }

        // X-Axis
        g.append("g")
            .attr("transform", "translate(0," + height + ")")
            .call(d3.axisBottom(xScale).tickFormat(addFootnoteToLabel))
            .selectAll(".tick text")
            .attr("font-size", DataItems.length > 5 ? "11px" : "14px")
            .call(wrap, xScale.bandwidth() + 20);

        // Y-Axis
        g.append("g")
            .attr("class", "grid")
            .call(
                d3
                    .axisLeft(yScale)
                    .tickFormat(function (d) {
                        return d;
                    })

                    .ticks(10)
            )
            .append("text")
            .attr("class", "yAxisLabel")
            .attr("fill", "black")
            .attr("font-size", "15")

            .attr("font-weight", "bold")
            .text(DataItems[0].DataValueType)
            .call(function (t) {
                t.each(function (d) { // for each one
                    var self = d3.select(this);
                    const s = self.text().split(' ');  // get the text and split it
                    const count = s.length;

                    const words_per_row = 8;
                    if (count < words_per_row) return;


                    const rows = parseInt(count / words_per_row) + 1;

                    self.text(''); // clear it out

                    for (var x = 0; x < rows; x++) {

                        if (s && s.length && s.length > 0) {
                            const num_to_take = s.length >= words_per_row ? words_per_row : s.length

                            self.append("tspan") // insert two tspans
                                .attr("x", 0).attr("font-size", "17")
                                .attr("dy", ".8em")

                                .text(s.slice(0, num_to_take).join(" "));


                            s.splice(0, num_to_take)

                        }
                    }
                    self.append("tspan") // insert two tspans
                        .attr("x", 0).attr("font-size", "17")
                        .attr("dy", "1em")

                        .text(DataValueUnit);





                    //    for (var w = 0; w < count; w++) {
                    //        words.push(s[wordIndex])
                    //        wordIndex++;
                    //    }
                    //
                    //    let wordIndex = 0;
                    //    for (var x = 0; x < rows; x++) {
                    //        let words = [];
                    //
                    //        for (var w = 0; w < words_per_row; w++) {
                    //            words.push(s[wordIndex])
                    //            wordIndex++;
                    //        }
                    //
                    //        self.append("tspan") // insert two tspans
                    //            .attr("x", 0)
                    //            .attr("dy", ".9em")
                    //            .text(words.join(" "));
                    //
                    //    }


                })
            }).attr("y", (DataItems[0].DataValueType + DataValueUnit).length > 50 ? "-15" : 0);

        g.selectAll(".grid .tick line").attr("x1", "-6").attr("x2", width);

        g.selectAll(".yAxisLabel text").attr("x", "100");



        g.selectAll("rect")
            .data(DataItems)
            .enter()
            .append("rect")
            .attr("class", "graph-text bar")
            .attr("x", (d) => xScale(d.Stratification))
            .attr("y", (d) => yScale(d.DataValue))
            .attr("fill", (d, i) => legendSymbols[i].color)
            .attr("width", xScale.bandwidth())
            .attr("height", (d) => height - yScale(d.DataValue))
            .attr("stratid", (d) => d.StratificationID)
            .attr("locid", (d) => d.LocationAbbr)
            .attr("aria-label", function (d, i) {
                return getAriaTextForMapLocation(d, i, d.LocationAbbr);
            })
            .on("mouseover", function (mouseEvent, locationInfo) {
                if (deviceType === "mobile") return;
                SetChartToolTip(mouseEvent, locationInfo);
            })
            .on("mouseout", function (mouseEvent) {
                if (deviceType === "mobile") return;
                if (mouseEvent.toElement == null) return;
                if (mouseEvent.toElement.id === id) {
                    ClearLocationToolTip(mouseEvent);
                }
            })
            .on("click", function (mouseEvent, locationInfo) {
                if (deviceType === "desktop") return;
                const toolTipOffSet = 0.25;
                SetChartToolTip(mouseEvent, locationInfo, toolTipOffSet);
            });

        g.selectAll(".bar")
            .data(DataItems)
            .append("title")
            .attr("fill", "black")
            .attr("font-size", "15")
            .attr("font-weight", "bold")
            .attr("x", (d) => xScale(d.Stratification))
            .attr("y", (d) => yScale(d.DataValue));

        g.selectAll("bar")
            .data(DataItems)
            .enter()
            .append("line")
            .attr("x1", (d) => {
                if (d.HighConfidenceLimit === null) return 0;
                return xScale(d.Stratification) + xScale.bandwidth() / 2;
            })
            .attr("x2", (d) => {
                if (d.HighConfidenceLimit === null) return 0;
                return xScale(d.Stratification) + xScale.bandwidth() / 2;
            })
            .attr("y1", (d) => yScale(d.HighConfidenceLimit))
            .attr("y2", (d) => yScale(d.LowConfidenceLimit))
            .attr("stroke", "black")
            .attr("stroke-width", 1);

        g.selectAll("bar")
            .data(DataItems)
            .enter()
            .append("line")
            .attr("x1", (d) => {
                if (d.HighConfidenceLimit === null) return 0;
                return xScale(d.Stratification) + xScale.bandwidth() / 2 - 10;
            })
            .attr("x2", (d) => {
                if (d.HighConfidenceLimit === null) return 0;
                return xScale(d.Stratification) + xScale.bandwidth() / 2 + 10;
            })
            .attr("y1", (d) => yScale(d.HighConfidenceLimit))
            .attr("y2", (d) => yScale(d.HighConfidenceLimit))
            .attr("stroke", "black")
            .attr("stroke-width", 1);

        g.selectAll("bar")
            .data(DataItems)
            .enter()
            .append("line")
            .attr("x1", (d) => {
                if (d.HighConfidenceLimit === null) return 0;
                return xScale(d.Stratification) + xScale.bandwidth() / 2 - 10;
            })
            .attr("x2", (d) => {
                if (d.HighConfidenceLimit === null) return 0;
                return xScale(d.Stratification) + xScale.bandwidth() / 2 + 10;
            })
            .attr("y1", (d) => yScale(d.LowConfidenceLimit))
            .attr("y2", (d) => yScale(d.LowConfidenceLimit))
            .attr("stroke", "black")
            .attr("stroke-width", 1);
    }

    function changeData() {
        ShowVerticalBarChart(datasets.DataItems);
    }

    function handleKeyDown(event) {
        var itemList = chartRef.current?.querySelectorAll(".graph-text");

        if (event.code === "Tab" && event.shiftKey) {
            //nothing. let's just catch it
        }
        else if (event.code === "End") {
            event.preventDefault();
            let nextIndex = null;
            if (isFirst) {
                nextIndex = 0;
                setIsFirst(false);
            } else {
                nextIndex = itemList.length - 1;
            }


            itemList.forEach((item, i) => {
                item.setAttribute("aria-selected", "false");
                item.classList.remove("graph-focus");
            });

            itemList[nextIndex].classList.add("graph-focus");
            itemList[nextIndex].focus();

            itemList[nextIndex].setAttribute("aria-selected", "true");
            setStateIndex(nextIndex);

            scrollIntoViewIfNotVisible(itemList[nextIndex]);

        }
        else if (event.code === "Home") {
            event.preventDefault();
            let nextIndex = null;
            if (isFirst) {
                nextIndex = 0;
                setIsFirst(false);
            } else {
                nextIndex = 0;
            }


            itemList.forEach((item, i) => {
                item.setAttribute("aria-selected", "false");
                item.classList.remove("graph-focus");
            });

            itemList[nextIndex].classList.add("graph-focus");
            itemList[nextIndex].focus();

            itemList[nextIndex].setAttribute("aria-selected", "true");
            setStateIndex(nextIndex);

            scrollIntoViewIfNotVisible(itemList[nextIndex]);

        }
        else if (event.code !== "Tab") {
            event.preventDefault();
            if (event.code === "ArrowDown") {
                console.log("arrow down");

                let nextIndex = null;
                if (isFirst) {
                    nextIndex = 0;
                    setIsFirst(false);
                } else {
                    nextIndex = stateIndex + 1;
                }

                if (nextIndex < itemList.length) {
                    itemList.forEach((item, i) => {
                        item.setAttribute("aria-selected", "false");
                        item.classList.remove("graph-focus");
                    });

                    itemList[nextIndex].classList.add("graph-focus");
                    itemList[nextIndex].focus();

                    //   chartRef .current?.setAttribute('aria-activedescendant', itemList[nextIndex].id);
                    itemList[nextIndex].setAttribute("aria-selected", "true");
                    setStateIndex(nextIndex);

                    scrollIntoViewIfNotVisible(itemList[nextIndex]);
                }
            } else if (event.code === "ArrowUp") {
                console.log("arrow up");

                let nextIndex = null;
                if (isFirst) {
                    nextIndex = 0;
                    setIsFirst(false);
                } else {
                    nextIndex = stateIndex - 1;
                }
                if (nextIndex > -1) {
                    itemList.forEach((item, i) => {
                        item.setAttribute("aria-selected", "false");
                        item.classList.remove("graph-focus");
                    });

                    //  chartRef .current?.setAttribute('aria-activedescendant', itemList[nextIndex].id);
                    itemList[nextIndex].setAttribute("aria-selected", "true");
                    itemList[nextIndex].classList.add("graph-focus");
                    itemList[nextIndex].focus();

                    setStateIndex(nextIndex);

                    scrollIntoViewIfNotVisible(itemList[nextIndex]);
                }
            } else if (event.code === "Enter") {
                const stratid = itemList[stateIndex].getAttribute("stratid");
                const locid = itemList[stateIndex].getAttribute("locid");
                const y = itemList[stateIndex].getAttribute("y");
                const x = itemList[stateIndex].getAttribute("x");

                const items = datasets.DataItems.filter(x => x.LocationAbbr === locid && x.StratificationID === stratid);
                if (items && items.length > 0) {
                    SetChartToolTipKeyboard(x, y, event, itemList[stateIndex], items[0])
                }
                //const textColor = getTextColor(itemList[stateIndex].id, topic_code);
                //const fillColor = getColor(itemList[stateIndex].id, topic_code);
                //ShowToolTip(itemList[stateIndex], itemList[stateIndex].id, true);
            }
        }
    }


    function scrollIntoViewIfNotVisible(target) {
        if (target.getBoundingClientRect().bottom > window.innerHeight) {
            target.scrollIntoView(false);
        }

        if (target.getBoundingClientRect().top < 0) {
            target.scrollIntoView();
        }
    }

    function handleBlur(event) {
        var itemList = chartRef.current?.querySelectorAll(".graph-text");

        itemList.forEach((item, i) => {
            item.classList.remove("graph-focus");
        });

        //setIsFirst(true);
        //setStateIndex(0);
    }
    function getAriaTextForMapLocation(d, i, locationCode) {
        const locations = datasets.DataItems.filter((x) => x.LocationAbbr === locationCode);
        const locationText = locations && locations.length > 0 ? locations[0].LocationDesc : null;

        if (locationText !== null) {
            const stratid = d.StratificationID;
            const locid = d.LocationAbbr;
            const items = datasets.DataItems.filter(x => x.LocationAbbr === locid && x.StratificationID === stratid);

            if (items.length > 0 && items[0].DataValue !== null) {
                return `Select to see data for ${d.Stratification}, ${locationText}`;
            }
            else {
                return `Data not available for ${d.Stratification}, ${locationText}`;
            }
        }
        else {

            return "Error creating text"
        }
    }
    return (<div
            onKeyDown={handleKeyDown}
            tabIndex="0"
            onBlur={handleBlur}
            role="listbox"
        aria-label="Vertical Bar Graph"            
        aria-keyshortcuts="ArrowUp,ArrowDown,Home,End"
        >
            <div id={id} ref={chartRef} className={`vertical-chart ${verticalChartOverflow}`}></div>
        </div>);
};

export default VerticalBarChart;
